export { TextDuoImages } from './TextDuoImages'
